import * as React from 'react';

import { inject, observer } from 'mobx-react';

import { CurrentHotelStore } from 'stores/current-hotel-store';
import { ReviewCardOnInfosite } from 'components/common/reviews/review-components';

export interface ReviewsListOnInfositeProps {
  currentHotel?: CurrentHotelStore;
}

@inject('currentHotel')
@observer
export class ReviewsListOnInfosite extends React.Component<ReviewsListOnInfositeProps> {
  public constructor(props) {
    super(props);
  }

  public render() {
    const { currentHotel } = this.props;

    const { reviews } = currentHotel;
    const maxReviews = Math.min(5, reviews.userReviews.length);

    if (reviews.userReviews && reviews.userReviews.length > 0) {
      return (
        <section className="review-cards">
          {reviews.userReviews.slice(0, maxReviews).map((review, index) => (
            <ReviewCardOnInfosite
              hideTopPadding={index === 0}
              review={review}
              key={review.reviewId}
              showBottomSeparator={index < maxReviews - 1}
            />
          ))}
        </section>
      );
    }

    return null;
  }
}
